import {
  Dialog,
  DialogPanel,
  DialogTitle,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import { Fragment, ReactNode } from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  size?: "sm" | "md" | "lg" | "xl";
  closeButton?: boolean;
  footer?: ReactNode;
  className?: string;
}

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  size = "md",
  closeButton = true,
  className = "",
  footer = <></>,
}: ModalProps) => {
  const sizeClasses = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        {/* Overlay */}
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black opacity-50" />
        </TransitionChild>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-2 text-center">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <DialogPanel
                className={`w-full ${sizeClasses[size]} transform  rounded-[20px] bg-white p-2 text-left align-middle shadow-xl transition-all ${className}`}
              >
                {/* Header with close button at the top-right */}
                {(title || closeButton) && (
      <div className="flex justify-between items-center mb-[33px] relative">
                  {title && (
                    <DialogTitle
                      as="h3"
                      className="text-[17px] font-bold leading-[100%] text-[#232323]"
                    >
                      {title}
                    </DialogTitle>
                  )}

                  {closeButton && (
                    <div
                      className=" top-0 right-0  text-gray-400 hover:text-gray-500 focus:outline-none"
                      onClick={onClose}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 28 29"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.9785 28.1001C6.52979 28.1001 0.359863 21.9434 0.359863 14.4814C0.359863 7.03271 6.5166 0.862793 13.9653 0.862793C21.4272 0.862793 27.5972 7.03271 27.5972 14.4814C27.5972 21.9434 21.4272 28.1001 13.9785 28.1001ZM13.9785 25.4238C20.043 25.4238 24.9209 20.5459 24.9209 14.4814C24.9209 8.41699 20.0298 3.55225 13.9653 3.55225C7.90088 3.55225 3.04932 8.41699 3.04932 14.4814C3.04932 20.5459 7.91406 25.4238 13.9785 25.4238ZM9.64111 20.0186C8.96875 20.0186 8.44141 19.4912 8.44141 18.8188C8.44141 18.5024 8.57324 18.2124 8.81055 18.0015L12.291 14.4946L8.81055 11.001C8.57324 10.7769 8.44141 10.4868 8.44141 10.1704C8.44141 9.51123 8.96875 8.99707 9.64111 8.99707C9.9707 8.99707 10.2476 9.11572 10.4717 9.35303L13.9653 12.8335L17.4854 9.33984C17.7358 9.08936 17.9995 8.9707 18.3291 8.9707C18.9883 8.9707 19.5156 9.49805 19.5156 10.1572C19.5156 10.4736 19.397 10.7505 19.1597 10.9878L15.666 14.4946L19.1465 17.9883C19.3838 18.2124 19.5024 18.5024 19.5024 18.8188C19.5024 19.4912 18.9751 20.0186 18.3159 20.0186C17.9731 20.0186 17.6831 19.8867 17.459 19.6626L13.9653 16.1821L10.498 19.6626C10.2739 19.8999 9.9707 20.0186 9.64111 20.0186Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                  )}
                </div>
                )}
        

                {/* Content */}
                <div className="">{children}</div>

                {/* Footer (optional) */}
                {footer && <div className="">{footer}</div>}
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default Modal;
